export enum IconSizes {
    xs = "1.4rem",
    s = "1.6rem",
    m = "2.0rem",
    l = "2.4rem",
    xl = "3rem",
    xxl = "6rem",
}
